import React from "react";
import { Link } from "react-router-dom";

interface Props {
  projectId: number;
}

const DevelopmentUpdatesBtn: React.FC<Props> = ({ projectId }) => {
  return (
    <section className="mb-[7rem]">
      <Link
        to={`/development-updates/${projectId}`}
        className="bg-blue-900 flex items-center border border-transparent text-white px-[1.2rem] py-[0.4rem] rounded-[0.5rem] h-[5rem] hover:bg-blue-700 max-w-max"
      >
        <p className="whitespace-nowrap p-[1rem]">Development Updates</p>
      </Link>
    </section>
  );
};

export default DevelopmentUpdatesBtn;
